import { render, staticRenderFns } from "./ReviewSubmission.vue?vue&type=template&id=0a7b766b&"
import script from "./ReviewSubmission.vue?vue&type=script&lang=js&"
export * from "./ReviewSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports